import React from 'react';
import moment from 'moment';

class TourDates extends React.Component {

  render() {
    const start = moment(this.props.start);
    if (!start.isValid()) {
      return (
        <span>
              -
        </span>);
    }
    return (
      <span>
        {moment(this.props.start).format('MMM DD') } - { moment(this.props.end).format('MMM DD, YYYY')}
      </span>

    );
  }
}
export default TourDates;



// WEBPACK FOOTER //
// src/routes/tours/components/TourDates.js